import { render, staticRenderFns } from "./TemplateSwitch.vue?vue&type=template&id=26830b2c&scoped=true&"
import script from "./TemplateSwitch.vue?vue&type=script&lang=js&"
export * from "./TemplateSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSwitch.vue?vue&type=style&index=0&id=26830b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26830b2c",
  null
  
)

export default component.exports